import React from "react";
import PropTypes from "prop-types";
import Contents from "./Contents";

const SectionContainerJustText = ({
    text,
    isH1,
    isH2,
    isH4,
    subtext,
    button
}) => {
    const isHeading1 = isH1 && !isH2 && !isH4;
    const isHeading2 = isH2 && !isH1 && !isH4;
    const isHeading4 = isH4 && !isH1 && !isH2;

    return (
        <Contents
            isHeading1={isHeading1}
            isHeading2={isHeading2}
            isHeading4={isHeading4}
            text={text}
            subtext={subtext}
            button={button}
        />
    );
};

SectionContainerJustText.propTypes = {
    text: PropTypes.string.isRequired,
    isH1: PropTypes.bool,
    isH2: PropTypes.bool,
    isH4: PropTypes.bool,
    subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    button: PropTypes.object
};

export { SectionContainerJustText };
